const selectStyle = Object.freeze({
  borderWidth: 1,
  lines: 0.000000000000000001,
  borderStyle: 'solid',
  verticalPaddingButton: '0.5rem',
});

export default selectStyle;
